import React from 'react';
import { generateColorForAsset } from '../utils/colorUtils';
import './CalendarSidebar.css'; // Assuming styles are in CalendarSidebar.css

function AssetSidebar({
  assets,
  selectedAssetIds,
  onAssetSelectionToggle,
  onSelectAll,
  onSelectNone,
  equipmentType,
  onEquipmentTypeChange,
  uniqueEquipmentTypes,
  loading,
  events = {}, // Default to empty object if not always provided
  collapsed = false // Add collapsed prop
}) {
  // Filter assets for the sidebar based on type
  const filteredAssetsForSidebar = equipmentType === 'all'
    ? assets
    : assets.filter(asset => {
        const type = asset.type || asset.category;
        return type ? type.toLowerCase() === equipmentType.toLowerCase() : false;
      });

  return (
    <div className={`asset-sidebar ${collapsed ? 'collapsed' : ''}`}>
      {!collapsed && (
        <>
          <h4>Assets</h4>
          <div className="asset-sidebar-controls">
            <button
              type="button"
              onClick={() => {
                const availableIds = filteredAssetsForSidebar
                  .filter(asset => asset.available)
                  .map(asset => asset._id);
                onSelectAll(availableIds);
              }}
            >
              Select All
            </button>
            <button type="button" onClick={onSelectNone}>
              Select None
            </button>
          </div>
          <div className="equipment-type-filter-sidebar">
            <label htmlFor="equipmentTypeSidebar">Filter by Type:</label>
            <select
              id="equipmentTypeSidebar"
              value={equipmentType}
              onChange={(e) => onEquipmentTypeChange(e.target.value)}
            >
              <option value="all">All Types</option>
              {uniqueEquipmentTypes.map(type => (
                <option key={type} value={type}>{type}</option>
              ))}
            </select>
          </div>
          <ul className="asset-list">
            {filteredAssetsForSidebar.length > 0 ? (
              filteredAssetsForSidebar.map(asset => {
                const assetId = asset._id;
                const isAssetAvailable = asset.available;
                const displayName = asset.name;

                return (
                  <li
                    key={assetId}
                    className={isAssetAvailable ? 'asset-item-available' : 'asset-item-unavailable'}
                  >
                    <input
                      type="checkbox"
                      id={`asset-checkbox-${assetId}`}
                      checked={selectedAssetIds.includes(assetId)}
                      onChange={() => onAssetSelectionToggle(assetId)}
                      disabled={!isAssetAvailable || (loading && !events[assetId])}
                      style={{
                        accentColor: generateColorForAsset(assetId)
                      }}
                    />
                    <label htmlFor={`asset-checkbox-${assetId}`}>
                      {displayName}
                    </label>
                  </li>
                );
              })
            ) : (
              <li>No assets match the current filter.</li>
            )}
          </ul>
        </>
      )}
      {collapsed && (
        <div className="collapsed-indicator">
          <div className="selected-count">
            {selectedAssetIds.length}
          </div>
        </div>
      )}
    </div>
  );
}

export default AssetSidebar;
